export default __webpack_public_path__ + "static/media/scrappy1.efd72e88.png";